'use strict';

import React from 'react';

const usingUat = location.hostname.indexOf('uat.') != -1;
const usingDev = location.hostname.indexOf('localhost') != -1;

const globalConfig = {
  map: {
    client: 'gme-nswruralfireservice',
    channel: 'PWS_FNM',
    default: {
      center: { lat: -32.728161, lng: 147.075831 },
      zoom: 6,
      minZoom: 5,
    },
  },
  collections: {
    default: {
      name: 'nsw-rfs-hazard-xml',
      displayName: 'Scheduled burns',
      displaySubtitle: 'week ahead',
      color: '#ff7700',
      styleType: 'type-1',
    },
    // 1: {
    //   name: 'nsw-rfs-hazard-xml2--void',
    //   displayName: 'Another collection',
    //   displaySubtitle: 'subtitle',
    //   color: '#0d8504',
    //   styleType: 'type-2',
    // },
  },
  messages: {
    noResults: 'There are no events to display.',
    tooManyResults: 'There are too many events. Please zoom in to see details.',
    loadDataFailed: 'Failed to load data! Please try again.',
    noResultsOverlayMsg: 'There are no scheduled events.',
  }
};

if (usingDev) {
  globalConfig.endpoints = {
    fb: {
      url: '/mysource_files/sampleData.json',
      numRanks: 10000,
    },
    infoPanel: {
      url: '//www.uat.rfs.nsw.gov.au/funnelback/query-builder',
    },
  };
} else if (usingUat) {
  globalConfig.endpoints = {
    fb: {
      url: '/funnelback/hr-map-data',
      numRanks: 10000,
    },
    infoPanel: {
      url: '/funnelback/query-builder',
    },
  };
} else {
  globalConfig.endpoints = {
    fb: {
      url: '/funnelback/hr-map-data',
      numRanks: 10000,
    },
    infoPanel: {
      url: '/ajax-contents/hr-map-menu-content',
    },
  };
}

export default globalConfig;
